import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

export const FormButton = styled.button`
  ${tw`shadow uppercase block w-full bg-white text-sm border border-gray-400 rounded py-3 px-4 mb-3 leading-tight font-bold tracking-wider focus:outline-none`}
`;

export const OptionButton = ``;
